export default __webpack_public_path__ + "static/27-3ae921d0c7e70b54f85fbb6778e20657.jpg";